<template>
  <div>
    <div class="time-sheet-container">
      <table class="time-sheet-table">
        <thead>
          <tr>
            <th colspan="2" class="title-tutor-name"><p></p></th>
            <th
              colspan="7"
              class="title-period"
              @click="sortBy('period')"
              :class="sortKey === 'period' ? sortDirection : null"
            >
              Period
            </th>
          </tr>
          <tr>
            <th
              class="tutor-name"
              :class="sortKey === 'tutor' ? sortDirection : null"
              @click="sortBy('tutor')"
            >
              Name
            </th>
            <th class="start-time">Start</th>
            <th v-for="period of periods" :key="period" class="period">
              {{ period }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="orderedClockIns.length === 0">
            <td class="no-data" colspan="9">No data available</td>
          </tr>
          <ClockInTableRecord
            v-for="(clockIn, idx) of orderedClockIns" :key="idx"
            :date="date" :clockIn="clockIn"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import _ from 'lodash'
import { Moment } from 'moment'
import { Periods } from '@/store/common.types'
import { ClockIn } from '@/store/clockIn/types'
import ClockInTableRecord from '@/components/parts/clockIn/ClockInTableRecord.vue'

@Component({
  components: {
    ClockInTableRecord,
  },
})
export default class ClockInList extends Vue {
  @Prop() clockIns!: ClockIn[]

  @Prop() date!: Moment

  private periods = Periods

  private ClockInList: any = ClockInList

  private sortKey: 'tutor'|'period'|null = null

  private sortDirection: 'asc'|'desc'|null = null

  /**
   * 並べ替え済みの打刻リスト
   * @returns {ClockIn[]}
   */
  private get orderedClockIns(): ClockIn[] {
    const assigned = _.filter(this.clockIns, 'tutor')
    const unAssigned = _.chain(this.clockIns)
      .filter((c) => c.tutor === null)
      .map((c) => {
        const base = _.omit(c, ['schedules'])
        return _.map(c.schedules, (s) => {
          return {
            ...base,
            schedules: [s],
          }
        })
      })
      .flatten()
      .value()

    const clockIns = [...unAssigned, ...assigned]
    if (this.sortKey === 'tutor') {
      return _.orderBy(clockIns, ['tutor.name'], [this.sortDirection as 'asc'|'desc'])
    }
    if (this.sortKey === 'period') {
      return _.orderBy(clockIns, ['schedules[0].startPeriod'], [this.sortDirection as 'asc'|'desc'])
    }
    return clockIns
  }

  /**
   * ソートのキーと方向設定
   * @param {string} ソートのキー
  */
  private sortBy(key: 'period'|'tutor') {
    if (this.sortKey !== key) {
      this.sortKey = key
      this.sortDirection = 'asc'
    } else {
      const directions = ['asc', 'desc', null]
      const directionPosition = _.indexOf(directions, this.sortDirection)
      this.sortDirection = directions[(directionPosition + 1) % 3] as 'asc'|'desc'|null
      if (this.sortDirection === null) {
        // ディレクションが一周してnullになった場合はソートのキーも解除
        this.sortKey = null
      }
    }
  }
}
</script>

<style scoped>
.d-flex {
  display:flex;
}

.time-sheet-container {
  margin-bottom: 30px;
  padding: 15px;
  background: #fff;
}

.time-sheet-table {
  width: 100%;
  background: #fff;
  border-collapse:collapse;
  user-select:none;
}

.time-sheet-table th {
  padding: 10px 0;
  vertical-align: top;
  text-align: center;
}

.time-sheet-table td {
  padding: 5px 0;
  border: 1px solid #B5B5B5;
  text-align: center;
}

.time-sheet-table td.not-assigned {
  border: none;
}

.time-sheet-table td.no-data {
  padding: 20px;
  text-align: center;
  font-size: 17px;
  border: 1px solid #B5B5B5;
};

.time-sheet-table td.tutor-name-box {
  padding:5px 10px;
}

th.tutor-name {
  position:relative;
  padding: 5px 0;
  background: #ededed;
  border: 1px solid #ededed;
  border-right: 2px solid #fff;

}

th.tutor-name:hover {
  background: #c6c6c6;
}

th.start-time {
  padding: 5px 0;
  width:60px;
  background: #ededed;
  border: 1px solid #ededed;
  border-right: 2px solid #fff;
}

th.period {
  padding: 5px 0;
  width: 100px;
  background: #B3C6E7;
  border: 1px solid #B3C6E7;
}

.date, .day {
  width: 35px;
}

.time-sheet-table td.period-box {
  position: relative;
  height: 40px;
  padding:0px;
}

.time-sheet-table td.period-box .period-box-container {
  display: flex;
  height:100%;
}

.time-sheet-table td.period-box .period-box-border {
  display: block;
  width: 100px;
  border-right:1px solid #B5B5B5;
}

.time-sheet-table td.period-box .period-box-border:last-child {
  border-right: none;
}

.mark {
  height:30px;
  position: absolute;
  top:0px;
  bottom:0px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-radius: 30px;
  font-size:12px;
}

.campusname-box {
  position: absolute;
  background: #ffffff;
  color:#000;
  right:2px;
  font-size: 10px;
  padding:3px;
  border:#2E75B5 2px solid;
  border-radius: 30px;
}

.mark.lesson {
  background: #DDEAF6;
  border:2px solid #DDEAF6;
}

.mark.waiting {
  background: #87A4D9;
  border:2px solid #87A4D9;
}

.mark.subLesson {
  background: #F7CAAC;
  border:2px solid #F7CAAC;
}

.mark.workshopOrTutorTraining {
  background: #C39BE1;
  border:2px solid #C39BE1;
}

.mark.meeting {
  background: #F38181;
  border:2px solid #F38181;
}

.mark.workOnHoliday {
  background: #55A8FD;
  border:2px solid #55A8FD;
}

.mark.lessonOnHolliday {
  background: #0070C0;
  border:2px solid #0070C0;
}

.mark.absent {
  background: #A5A5A5;
  border:2px solid #A5A5A5;
}

.note {
  text-align: left;
  margin-left:10px;
}

.title-period , .title-tutor-name {
  background: #ededed;
  border-bottom: 2px solid #fff;
}

th.title-period:hover {
  background: #c6c6c6;
}

.title-tutor-name {
  border-right: 2px solid #fff;
}

.title-note {
  background: #ededed;
  border-left: 2px solid #fff;
}

.tutor-name-box .d-flex {
  justify-content: flex-end;
}

.schedule-line .tutor-name-box .tutor-number {
  padding:1px 10px;
  background: #E9F0F7;
  color: #000;
  border-radius: 30px;
  margin-right: 5px;
}

.schedule-line.red {
  background: #F06262;
  color: #fff;
}

.schedule-line.blue {
  background: #BBD6EE;
}

.schedule-line.gray {
  background: #D8D8D8;
}

.schedule-line.yellow {
  background: #ffffb3;
}

.schedule-line.white {
  background: #FFFFFF;
}

.schedule-line.orange {
  background: #ffd9b3;
}

.asc::after {
  margin-left:5px;
  content: "▼";
}
.desc::after {
  margin-left:5px;
  content: "▲";
}

</style>
